<template>
  <div>
    <a ref="attachmentA"></a>
     <stepheader :step="step"/>
    <div
      id="wizard2-p-0"
      role="tabpanel"
      aria-labelledby="wizard2-h-0"
      class="body current"
      aria-hidden="false"
      style=""
    >
      <div class="row">
        <div class="col-12">
        
          <div
            class="selectgroup-pills"
            v-for="(danno, index) in danni"
            v-bind:key="index"
          >
            <label class="selectgroup-item " style="display:block">
              <input
                type="checkbox"
                name="value"
                v-bind:value="danno"
                v-model="danniSelezionati"
                class="selectgroup-input"
                checked=""
              />
              <span class="selectgroup-button text-start">{{ danno.descrizione }}</span>
            </label>
          </div>
        </div>
        <div class="col-12" v-if="step.showAnomalia">
          <label class="form-label" for="anomalia"
            >Indicare eventuali anomalie diverse da quelle indicate sopra:
            <span class="tx-danger" v-if="step.required">*</span></label
          >
          <textarea v-model="ticket.anomalia" class="form-control"></textarea>
        </div>
      </div>
    </div>

    <buttons :buttons="step.buttons" v-on:action="fireaction"></buttons>
  
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "danni",
  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    attachments: {
      type: Array,
      required: false,
      default: () => [],
    },
    ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      danni: [],
      danniSelezionati: [],
    };
  },
  computed: {},
  components: {},
  mounted() {
    setTimeout(this.loaddata, 100);
  },
  methods: {
    setDanno: function (danno) {
      this.ticket.danni = this.ticket.danni.filter(
        (x) => x.idTipologiaDanno != parseInt(this.step.categorytype)
      );
      this.ticket.danni.push(danno);
      var b = this.step.buttons.filter((x) => x.action == "next")[0];
      this.fireaction(b.action, b.nextstep);
    },
    fireaction: function (action, nextstep) {
      this.ticket.danni = this.ticket.danni.filter(
        (x) => x.idTipologiaDanno != parseInt(this.step.categorytype)
      );
      for (let index = 0; index < this.danniSelezionati.length; index++) {
        const element = this.danniSelezionati[index];
         this.ticket.danni.push(element);
      }
     
      switch (action) {
        case "next":
          if (
        this.ticket.danni.filter(
              (x) => x.idTipologiaDanno == parseInt(this.step.categorytype)
            ).length == 0 && this.step.required  && this.ticket.anomalia ==''
          ) {
            swal({
              title: "Errore di compilazione",
              text: "Selezionare una voce",
              type: "error",
              showCancelButton: false,
              toast: false,
              timer: 2000,
              showConfirmButton: false,
              position: "bottom-top",
            });
          } else {
            this.$emit("goto", nextstep);
          }
          break;
        default:
          this.$emit("goto", nextstep);
          break;
      }
    },

    loaddata: function () {
      axios.get("danni/getall").then((response) => {
        console.log("danni", response);
        this.danni = response.data.results.filter(
          (x) => x.idTipologiaDanno == parseInt(this.step.categorytype)
        );
      });
    },
  },
};
</script>